import { render, staticRenderFns } from "./OpenCartEdit.vue?vue&type=template&id=d244bff2&scoped=true&"
import script from "./OpenCartEdit.vue?vue&type=script&lang=js&"
export * from "./OpenCartEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d244bff2",
  null
  
)

export default component.exports